function comparable (name: string): string {
  return name.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase('fr-FR');
}

export function familyNamesLabel (
  borrower: string | null | undefined,
  coBorrower: string | null | undefined,
): string | null {
  const names = [borrower, coBorrower]
    .map(name => name?.trim() ?? '')
    .filter(name => name !== '');
  const [first, second] = names;
  if (first === undefined) { return null; }

  return second === undefined || comparable(first) === comparable(second) ? first : `${first} & ${second}`;
}
